"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormModal = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_state_1 = require("../../components/input/input.state");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var spinner_1 = require("../../components/spinner/spinner");
var table_1 = require("../../components/table/table");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var store_1 = require("../../store");
var collection_form_modal_ctrl_1 = require("./collection.form.modal.ctrl");
var collection_form_modal_style_1 = require("./collection.form.modal.style");
(0, theme_1.addStyles)(collection_form_modal_style_1.Style);
var CollectionFormModal = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionFormModal, _super);
    function CollectionFormModal(ctx, collections) {
        var _this = _super.call(this, ctx) || this;
        _this.departmentForms = [];
        _this.errors = [];
        _this.ctrl = new collection_form_modal_ctrl_1.CollectionFormModalCtrl(collections);
        _this.errorState = new input_state_1.InputState(i18n_1.T.ERROR);
        _this.loadingState = new input_state_1.InputState(i18n_1.T.LOADING);
        _this.addState(_this.errorState);
        _this.addState(_this.loadingState);
        store_1.AppStore.FormSummary.refresh();
        return _this;
    }
    Object.defineProperty(CollectionFormModal.prototype, "nodes", {
        get: function () {
            this.departmentForms = store_1.AppStore.FormSummary.all;
            if (this.departmentForms.length === 0) {
                this.loadingState.setError(i18n_1.T.LOADING);
                return spinner_1.Spinner.view();
            }
            this.loadingState.reset();
            return (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.content }, [
                    this.errorsTable
                ]),
                (0, mithril_1.m)('div', { className: collection_form_modal_style_1.CSS.content }, [
                    this.viewStats()
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionFormModal.prototype, "errorsTable", {
        get: function () {
            if (this.errors.length === 0) {
                return null;
            }
            var title = (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_ERROR_TITLE, { count: this.errors.length });
            var headers = [(0, i18n_1.Translate)(i18n_1.T.COLLECTION_TITLE), (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_REASON), (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_NAME), (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_VALUE)];
            var rows = [];
            this.errors.forEach(function (error) {
                var values = '';
                if (error.failure.values) {
                    var failure = error.failure;
                    values = failure.values.toString();
                }
                var reason = {
                    missing: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_MISSING),
                    replace: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_FIELD_VALUE_MISSING)
                };
                rows.push([
                    (0, mithril_1.m)('span', { title: error.collectionTitle }, error.collectionTitle),
                    (0, mithril_1.m)('span', { title: reason[error.failure.reason] }, reason[error.failure.reason]),
                    (0, mithril_1.m)('span', { title: error.failure.fieldName }, error.failure.fieldName ? error.failure.fieldName : error.failure.fieldId),
                    (0, mithril_1.m)('span', { title: values }, values)
                ]);
            });
            return table_1.Table.view(title, headers, rows);
        },
        enumerable: false,
        configurable: true
    });
    CollectionFormModal.prototype.viewStats = function () {
        var collectionStats = this.ctrl.getCollectionStats(this.departmentForms);
        var title = (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_CONFIRM, { count: this.ctrl.collections.length });
        var headers = [(0, i18n_1.Translate)(i18n_1.T.COLLECTION_TITLE), (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_CURRENT_REVISION), (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_FORM_LATEST_REVISION), (0, i18n_1.Translate)(i18n_1.T.FORM_NAME)];
        var rows = [];
        collectionStats.forEach(function (stat) {
            var latestFormDate = stat.latestFormDate ? services_1.Services.DateTime.formatDateTime(stat.latestFormDate) : '';
            var latestFormField = stat.latestFormRevision ? latestFormDate : (0, i18n_1.Translate)(i18n_1.T.FORM_NOT_FOUND);
            var actualFormDate = stat.actualFormDate ? services_1.Services.DateTime.formatDateTime(stat.actualFormDate) : '';
            var actualFormField = stat.latestFormRevision === stat.actualFormRevision ? (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UPDATE_HAS_LATEST_FORM) : actualFormDate;
            rows.push([
                (0, mithril_1.m)('span', { title: stat.collectionTitle }, stat.collectionTitle),
                (0, mithril_1.m)('span', { title: actualFormField }, actualFormField),
                (0, mithril_1.m)('span', { title: latestFormField }, latestFormField),
                (0, mithril_1.m)('span', { title: stat.latestFormName }, stat.latestFormName)
            ]);
        });
        return table_1.Table.view(title, headers, rows);
    };
    CollectionFormModal.prototype.failToChange = function () {
        this.errors = this.ctrl.failures;
        this.errorState.setError(i18n_1.T.ERROR);
    };
    CollectionFormModal.prototype.submit = function () {
        return this.ctrl.updateFormCollections();
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionFormModal.prototype, "errors", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], CollectionFormModal.prototype, "errorsTable", null);
    return CollectionFormModal;
}(modal_form_component_1.ModalFormComponent));
exports.CollectionFormModal = CollectionFormModal;
//# sourceMappingURL=collection.form.modal.js.map